import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import {useRecoilValue} from "recoil";
import {numberOfRootQuestionState, currentQuestionIndexState} from "../../states/test_progress_states";

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 4,
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}))(LinearProgress);

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
});

const CustomizedProgressBars = ({isShowProcessBar}) => {
    const classes = useStyles();
    const numberOfQuestion = useRecoilValue(numberOfRootQuestionState);
    const currentQuestionIndex = useRecoilValue(currentQuestionIndexState);
    const process = (currentQuestionIndex / numberOfQuestion) * 100;

    if (isShowProcessBar) {
        return (
            <div className={classes.root}>
                <BorderLinearProgress variant="determinate" value={process}/>
            </div>
        );
    }
    return <></>;
};

export default CustomizedProgressBars;
